import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

// 静态路由
const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    name: "Login",
    path: "/login",
    meta: {
      title: "登录",
    },
    component: () => import("../view/Login"),
  },
  {
    name: "Register",
    path: "/register",
    meta: {
      title: "注册",
    },
    component: () => import("../view/Register"),
  },
  {
    name: "Forgot",
    path: "/forgot",
    meta: {
      title: "忘记密码",
    },
    component: () => import("../view/Forgot"),
  },
  {
    name: "Home",
    path: "/home",
    component: () => import("../view/Home"),
    redirect: "home/chat",
    children: [
      {
        name: "Chat",
        path: "chat",
        meta: {
          title: "Aitalky",
        },
        component: () => import("../view/Chat"),
      },
      {
        name: "Friend",
        path: "friend",
        component: () => import("../view/Friend"),
      },
      {
        name: "GROUP",
        path: "group",
        component: () => import("../view/Group"),
      },
      {
        name: "Setting",
        path: "setting",
        component: () => import("../view/Setting"),
        redirect: to => {
          const routes = store.state.userStore.routers || [];
          if (routes.length) {
            return `/home/setting/${routes[0].path}`;
          } else {
            return "/home/setting/messenger";
          }
        },
        children: [],
      },
    ],
  },
];

const router = new VueRouter({ routes });

// 全局路由守卫
router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  const hasMenu = store.state.userStore.menu?.length > 0;
  if (
    !hasMenu &&
    to.path !== "/login" &&
    to.path !== "/register" &&
    to.path !== "/forgot" &&
    to.path !== "/"
  ) {
    try {
      await store.dispatch("loadRouters");
      await store.dispatch("loadUserInfo");
      next({ ...to, replace: true });
    } catch (err) {
      next("/login");
    }
  } else {
    next();
  }
});

export default router;
